import { isNullOrUndefined } from "util";
import {StateTypes, TicketTypes, UserTypes} from "../../common/enums";
import { DateTimeHelper } from "../../utils/DateTimeHelper.util";
import moment = require("moment");
import { IBaseFilterParameter } from "../base-filter.parameter";

export interface INotificationParameter extends IBaseFilterParameter {
  is_watched?: boolean
}
export interface INotificationOptions {
  [prop: string]: any
}
export interface IHeaderNotification {
  isToday?: boolean
  action?: {
    id?: number,
    channel?: any,
    action_type?: string,
    actor?: { entity?: { firstname?: string, lastname?: string } },
    createdAt: string;
  };
  createdAt: string;
  fk_notification_action?: any;
  fk_notification_entity?: any;
  is_watched?: boolean;
  send_by_mail?: string;
  send_by_sms?: string;
  updatedAt?: string;
  id?: number
  type?: string
  deletedAt?: string
  fk_notif_details?: number
  fk_notification_creator?: number
  [x: string]: any

}
export class HeaderNotification {
  /**
   *
   */
  id: number;
  action?: {
    type?: string
    channel?: any,
    action_type?: string,
    actor?: { entity?: { firstname?: string, lastname?: string } },
    createdAt: string;
    appointment_actions: {
      appointment: {
        start_date: string
        end_date: string
      }
    }
  };
  createdAt: string;
  fk_notification_action?: any;
  fk_notification_entity?: any;
  is_watched?: boolean;
  send_by_mail?: string;
  send_by_sms?: string;
  updatedAt?: string;
  type?: string
  deletedAt?: string
  fk_notif_details?: number
  fk_notification_creator?: number
  creator?: any
  notifDetails?: any

  get redirectTo(): string {
    if (this.type === "create_event") {
      return "/agenda"
    } else if (this.type === "rp_action" || this.type === "create_bm_meeting_rp" || this.type === "maintenance" ) {
      return this.notifDetails.path
    } else {
      return `/ticket/${this.action.channel.ticket.id}/channel/${this.action.channel.id}`
    }
  }

  colorClass(): string {
    return this.is_watched === true ? 'whitePure' : 'backgroundGrey';
  }
  textColorClass(): string {
    return this.is_watched === true ? '' : 'primary--text';
  }
  get visible(): boolean {
    return !isNullOrUndefined(this.action) && !isNullOrUndefined(this.action.channel);
  }
  get actionOwnerName(): string {
    if (this.visible) {

      let isRequest: boolean = false
      if (this.action.action_type === StateTypes.MandateRequest || this.action.action_type === StateTypes.QuoteRequest) {
        isRequest = true
      }
      const actionOnwer: string = isRequest ? 'concern_actor' : 'actor';
      const owner = this.action[actionOnwer].entity;


      let ownerType: string = '';
      if ((isRequest || this.notifDetails) && owner.type === UserTypes.IndependentContractor) {
        ownerType = 'intervenant'
      }
      return `${ownerType}${owner.firstname} ${owner.lastname}`;
    }
    return null;
  }

  get textAvatar(): string {
    if (this.action) {
      const isRequest: boolean = this.action.action_type === (StateTypes.MandateRequest || StateTypes.QuoteRequest)
      const actionOnwer: string = isRequest ? 'concern_actor' : 'actor';
      const owner = this.action[actionOnwer].entity;
      return `${owner.firstname.substring(1, 0)}${owner.lastname.substring(1, 0)}`
    }
    else return `${this.creator.firstname.substring(1, 0)}${this.creator.lastname.substring(1, 0)}`
  }

  get subInfo(): string {
    let fromNow: string = ''
    let formattedInfo: string = ''
    if (this.action) {
      let notificationType: string;
      if (this.action.channel.ticket.pb_type === TicketTypes.Private)
        notificationType = '#G-';
      else if (this.action.channel.ticket.pb_type === TicketTypes.Public) {
        notificationType = '#S-';
      } else {
        notificationType = '#I-';
      }
      fromNow = moment(this.action.createdAt).fromNow()
      formattedInfo = `[${notificationType}${this.action.channel.ticket.id}]`
    }
    else {
      formattedInfo = DateTimeHelper.parseDateTime(this.notifDetails.createdAt)
      fromNow = moment(this.notifDetails.createdAt).fromNow()
    }

    formattedInfo += `<i style="margin-left: 10px;">${fromNow}</i>`
    return formattedInfo
  }
  get actionDetail(): any {
    if (this.action && this.action.action_type.indexOf('appointment') > -1
      && this.action.appointment_actions
      && this.action.appointment_actions.appointment) {
      return {
        date: DateTimeHelper.parseDate(this.action.appointment_actions.appointment.start_date),
        time: DateTimeHelper.parseTime(this.action.appointment_actions.appointment.start_date),
        endDate: DateTimeHelper.parseDate(this.action.appointment_actions.appointment.end_date),
        endTime: DateTimeHelper.parseTime(this.action.appointment_actions.appointment.end_date)
      }
    } else
      return null
  }

  get name(): string {

    if (this.action) {
      return this.action.channel.ticket.subject
    } else {
      return this.notifDetails.name
    }
  }
  get daysDiff(): number {
    return moment().diff(this.createdAt, 'd');
  }

  constructor(opt?: INotificationOptions | HeaderNotification) {
    Object.keys(opt).forEach((key: string) => {
      this[key] = opt[key];
    })
  }

}



// WEBPACK FOOTER //
// ./src/models/generic/generic-header-notification.ts